import React from 'react';

const GuideHeart = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        d="M16.5255 42.1401L16.5355 42.1301L16.5255 42.1401Z"
        fill="#8646F2"
        stroke="#212121"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.5308 42.2872L63.5208 42.2772L63.5308 42.2872Z"
        fill="#8646F2"
        stroke="#212121"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.4663 19.6854C47.128 19.6699 42.484 22.3874 39.9769 26.4289C37.4466 22.3642 32.7872 19.6235 27.4489 19.608C19.4492 19.5847 12.9769 25.6779 13.0001 33.2266C13.0078 36.6254 14.3423 39.73 16.5332 42.1301L36.9143 62.6703C38.6732 64.4432 41.5274 64.4432 43.2863 62.6703L63.5208 42.2772C65.6963 39.8926 67.0077 36.7957 67 33.3969C66.9768 25.8482 60.466 19.7164 52.4663 19.6854Z"
        fill="#8646F2"
        stroke="#212121"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.7777 24.6791C53.7931 20.026 50.8 16.2401 47.0894 16.2168C43.3788 16.1936 40.3626 19.9486 40.3394 24.6017C40.324 29.2548 43.3171 33.0407 47.0277 33.0639C50.7383 33.0872 53.7545 29.3322 53.7777 24.6791Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.7037 24.6094C46.7114 22.4107 45.292 20.6145 43.5331 20.6067C41.7743 20.599 40.3471 22.3719 40.3394 24.5707C40.3317 26.7695 41.7511 28.5657 43.51 28.5735C45.2688 28.5812 46.696 26.8082 46.7037 24.6094Z"
        fill="#212121"
      />
      <path
        d="M40.5014 24.4624C40.5168 19.8093 37.5237 16.0233 33.8131 16.0001C30.1026 15.9769 27.0863 19.7319 27.0632 24.3849C27.0477 29.038 30.0409 32.824 33.7514 32.8472C37.462 32.8704 40.4783 29.1154 40.5014 24.4624Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.4197 24.3771C33.4274 22.1784 32.008 20.3822 30.2492 20.3744C28.4903 20.3667 27.0632 22.1396 27.0555 24.3384C27.0477 26.5372 28.4672 28.3334 30.226 28.3412C31.9849 28.3489 33.412 26.5759 33.4197 24.3771Z"
        fill="#212121"
      />
      <path
        d="M54.3871 33.0484C53.4691 31.8794 52.0651 31.1284 50.4914 31.1051C47.6834 31.0587 45.3769 33.3426 45.346 36.215"
        fill="#8646F2"
      />
      <path
        d="M54.3871 33.0484C53.4691 31.8794 52.0651 31.1284 50.4914 31.1051C47.6834 31.0587 45.3769 33.3426 45.346 36.215"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GuideHeart;
